var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import * as React from "react";
import { compose, graphql, isSufficientPermission, returnError, withGraphqlErrorFlags, withLoadingSpinner, withServiceNotFoundHandler, withShowFlag, ButtonModal, EditableDynamicTable, EditablePage, Field, PageLayout } from "@atlassiansox/microscopekit";
import serviceQuery from "../models/service-query.query.graphql";
import { Permission } from "../../__generated__/graphql-global-types";
import { ButtonGroup } from "@atlaskit/button";
import { CreateClassificationForm } from "../components/create-classification-form";
import updateServiceMutation from "../models/update-service.mutation.graphql";
import WizardHelp from "../../drawers/microswizard/wizardhelp";
var ClassificationCellEdit = /** @class */ (function (_super) {
    __extends(ClassificationCellEdit, _super);
    function ClassificationCellEdit() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ClassificationCellEdit.prototype.render = function () {
        return React.createElement(React.Fragment, null, this.props.defaultValue);
    };
    return ClassificationCellEdit;
}(React.Component));
var DataClassificationsView = /** @class */ (function (_super) {
    __extends(DataClassificationsView, _super);
    function DataClassificationsView(props) {
        var _this = _super.call(this, props) || this;
        _this.tableFields = [
            {
                key: "dataType",
                headContent: "Data Type",
                isSortable: true,
                isDefaultSortKey: true,
                defaultSortOrder: "ASC",
                editableContent: (React.createElement(ClassificationCellEdit, { isDisabled: true, defaultValue: "", onChange: function () { } }))
            },
            {
                key: "explanation",
                headContent: "Explanation",
                isSortable: true,
            }
        ];
        _this.createNewClassification = function (data) { return __awaiter(_this, void 0, void 0, function () {
            var id, etag, classifications_1, newClassification, currentClassifications, updatedService, _a, message, graphQLErrors, errorMessage;
            var _b;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        if (!data.createClassificationForm) return [3 /*break*/, 4];
                        id = this.props.id;
                        etag = (this.props.data.service.attributes.dataClassificationsAttribute ||
                            { etag: undefined }).etag;
                        classifications_1 = [];
                        newClassification = {
                            dataType: data.createClassificationForm.classificationValue,
                            explanation: data.createClassificationForm.descriptionValue,
                        };
                        currentClassifications = (_b = this.props.data.service.attributes.dataClassificationsAttribute) === null || _b === void 0 ? void 0 : _b.value;
                        if (currentClassifications) {
                            currentClassifications.forEach(function (classification) { return classifications_1.push({
                                dataType: classification.dataType,
                                explanation: classification.explanation
                            }); });
                        }
                        classifications_1.push(newClassification);
                        _c.label = 1;
                    case 1:
                        _c.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, this.props.updateService({
                                variables: {
                                    input: {
                                        id: id,
                                        attributes: {
                                            dataClassificationsAttribute: {
                                                etag: etag,
                                                value: classifications_1
                                            }
                                        }
                                    }
                                }
                            })];
                    case 2:
                        updatedService = _c.sent();
                        if (updatedService) {
                            this.props.showFlag({
                                type: "success",
                                title: "Success",
                                message: "New Data Classification added."
                            });
                        }
                        else {
                            this.props.showFlag({
                                type: "error",
                                title: "Error",
                                message: "Create Data Classification request did return updated service."
                            });
                        }
                        return [3 /*break*/, 4];
                    case 3:
                        _a = _c.sent();
                        message = _a.message, graphQLErrors = _a.graphQLErrors;
                        errorMessage = returnError(graphQLErrors, message)[0];
                        this.props.showFlag({
                            type: "error",
                            title: "Error",
                            message: errorMessage
                        });
                        return [3 /*break*/, 4];
                    case 4: return [2 /*return*/];
                }
            });
        }); };
        _this.onSave = function (data) { return __awaiter(_this, void 0, void 0, function () {
            var id, etag, remainingClassifications, _a, message, graphQLErrors, errorMessage;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        id = this.props.id;
                        etag = (this.props.data.service.attributes.dataClassificationsAttribute || { etag: undefined }).etag;
                        remainingClassifications = data.dataClassifications.map(function (classification) { return ({
                            dataType: classification.dataType,
                            explanation: classification.explanation
                        }); });
                        _b.label = 1;
                    case 1:
                        _b.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, this.props.updateService({
                                variables: {
                                    input: {
                                        id: id,
                                        attributes: {
                                            dataClassificationsAttribute: {
                                                etag: etag,
                                                value: remainingClassifications
                                            }
                                        }
                                    }
                                }
                            })];
                    case 2:
                        _b.sent();
                        this.props.showFlag({
                            type: "success",
                            title: "Success",
                            message: "Data Classifications successfully updated."
                        });
                        return [3 /*break*/, 4];
                    case 3:
                        _a = _b.sent();
                        message = _a.message, graphQLErrors = _a.graphQLErrors;
                        errorMessage = returnError(graphQLErrors, message)[0];
                        this.props.showFlag({
                            type: "error",
                            title: "Error",
                            message: errorMessage
                        });
                        return [3 /*break*/, 4];
                    case 4: return [2 /*return*/];
                }
            });
        }); };
        _this.onSelect = function (classifications) {
            _this.setState({ classificationList: classifications });
        };
        _this.onSubmit = function () { return __awaiter(_this, void 0, void 0, function () {
            var id, etag, classifications_2, currentClassifications, updatedService, _a, message, graphQLErrors, errorMessage;
            var _b;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        if (!(this.state.classificationList.length > 0)) return [3 /*break*/, 4];
                        id = this.props.id;
                        etag = (this.props.data.service.attributes.dataClassificationsAttribute ||
                            { etag: undefined }).etag;
                        classifications_2 = [];
                        currentClassifications = (_b = this.props.data.service.attributes.dataClassificationsAttribute) === null || _b === void 0 ? void 0 : _b.value;
                        if (currentClassifications) {
                            currentClassifications.forEach(function (classification) { return classifications_2.push({
                                dataType: classification.dataType,
                                explanation: classification.explanation
                            }); });
                        }
                        this.state.classificationList.forEach(function (classification) { return classifications_2.push({
                            dataType: classification,
                            explanation: "*EDIT THIS DESCRIPTION*"
                        }); });
                        _c.label = 1;
                    case 1:
                        _c.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, this.props.updateService({
                                variables: {
                                    input: {
                                        id: id,
                                        attributes: {
                                            dataClassificationsAttribute: {
                                                etag: etag,
                                                value: classifications_2
                                            }
                                        }
                                    }
                                }
                            })];
                    case 2:
                        updatedService = _c.sent();
                        if (updatedService) {
                            this.props.showFlag({
                                type: "success",
                                title: "Success",
                                message: "Please select EDIT to add explanations for each Data Type and then SAVE. If you need additional assistance, refer to the DAC."
                            });
                        }
                        else {
                            this.props.showFlag({
                                type: "error",
                                title: "Error",
                                message: "Create Data Classification request did return updated service."
                            });
                        }
                        return [3 /*break*/, 4];
                    case 3:
                        _a = _c.sent();
                        message = _a.message, graphQLErrors = _a.graphQLErrors;
                        errorMessage = returnError(graphQLErrors, message)[0];
                        this.props.showFlag({
                            type: "error",
                            title: "Error",
                            message: errorMessage
                        });
                        return [3 /*break*/, 4];
                    case 4: return [2 /*return*/];
                }
            });
        }); };
        _this.state = {
            classificationList: []
        };
        return _this;
    }
    DataClassificationsView.prototype.componentDidMount = function () {
        document.title = this.props.data.service.id + "| Data Classifications";
    };
    DataClassificationsView.prototype.componentWillUnmount = function () {
        document.title = "Microscope";
    };
    DataClassificationsView.prototype.notEmpty = function (value) {
        return value !== null && value !== undefined;
    };
    DataClassificationsView.prototype.render = function () {
        var _a;
        var service = this.props.data.service;
        var classificationValues = (_a = service.attributes.dataClassificationsAttribute) === null || _a === void 0 ? void 0 : _a.value;
        var classifications = (classificationValues || []).filter(this.notEmpty);
        var classificationsToDisplay = classifications.map(function (classification, idx) { return ({
            key: idx.toString(),
            dataType: classification.dataType,
            explanation: classification.explanation
        }); });
        var newClassificationButton = (React.createElement(ButtonGroup, null,
            React.createElement(WizardHelp, { classificationList: this.state.classificationList, onSelect: this.onSelect, buttonText: "Data Classification Wizard", platform: service.metadata.platform, onSubmit: this.onSubmit }),
            React.createElement(ButtonModal, { buttonText: "New Classification", heading: "Add a new Data Classification", actions: {
                    submit: {
                        text: "Save",
                        onSubmit: this.createNewClassification
                    },
                    close: {
                        text: "Close"
                    }
                }, scrollBehavior: "outside" },
                React.createElement(Field, { name: "createClassificationForm", label: "Data Type", defaultValue: {} }, function (_a) {
                    var fieldProps = _a.fieldProps;
                    return (React.createElement(CreateClassificationForm, __assign({}, fieldProps)));
                }))));
        if (service.metadata.platform === "micros") {
            return (React.createElement(PageLayout, { title: "Data Classifications" },
                React.createElement("p", null,
                    "This is a Micros service. To update data classifications for this service, refer to the ",
                    React.createElement("b", null, "Update Data Classified Service Descriptor"),
                    " option from Microscope's ",
                    React.createElement("b", null, "Create"),
                    " button.")));
        }
        return (React.createElement(EditablePage, { title: "Data Classifications", onSave: this.onSave, isEditable: isSufficientPermission(service.currentUserPermission, Permission.Write), actions: isSufficientPermission(service.currentUserPermission, Permission.Write) ? newClassificationButton : undefined },
            React.createElement("h5", null, "If you are new to Data Classifications, begin with the Data Classification Wizard."),
            React.createElement("p", null,
                "The table below displays the Data Classifications for this service. If it is empty or incomplete, please update the classifications accordingly. Ensure there are ",
                React.createElement("b", null, "no duplicate data types"),
                "."),
            React.createElement("p", null,
                "For more detailed descriptions of data-types, refer to ",
                React.createElement("a", { href: "http://go.atlassian.com/labelingSchema", target: "_blank" }, "DAC"),
                ". For information on guidelines, refer to ",
                React.createElement("a", { href: "https://developer.atlassian.com/platform/data-classification/labeling-schema/guidelines-faq/", target: "_blank" }, "FAQ"),
                "."),
            React.createElement("br", null),
            React.createElement(EditableDynamicTable, { name: "dataClassifications", fields: this.tableFields, defaultValue: classificationsToDisplay, allowDelete: function () { return true; }, emptyView: React.createElement("div", null, "This serivce has no data classifications") })));
    };
    return DataClassificationsView;
}(React.Component));
export { DataClassificationsView };
export var DataClassificationsPage = compose(graphql(serviceQuery, {}), graphql(updateServiceMutation, {
    name: "updateService"
}), withLoadingSpinner, withShowFlag, withGraphqlErrorFlags, withServiceNotFoundHandler)(DataClassificationsView);
